import React, {Component} from 'react'
import PerformanceDetail from "../../../components/OA/PerformanceDetail";
import {withRouter} from "react-router-dom";

class SubordinatePerformanceDetail extends Component {
    state = {
        userId:this.props.match.params.id!=0?this.props.match.params.id:null,

    }
    componentDidMount(){
        console.log(this.props.history)
    }
    render() {
        const  locationQuery = new URLSearchParams(window.location.search)

        const periodId = locationQuery.get('periodId')||undefined
        return (
            <>
                <PerformanceDetail id={this.state.userId} periodId={periodId}/>
            </>
        )
    }
}
export default withRouter(SubordinatePerformanceDetail)